import moment from "moment";

export const formatDate = (date, format = "MM/DD/YYYY") =>
  moment(date, "YYYY-MM-DD HH:mm:ss a").format(format);

export const isDateAfterToday = (date) =>
  moment(date, "YYYY-MM-DD HH:mm:ss a").isAfter(moment());

export const isRegistrationActive = (registration) =>
  registration.status.toLowerCase() !== "canceled";

export const isRyderCupEvent = (event) => event.slug.includes("ryder-cup");

export const isPGAChampionshipEvent = (event) =>
  event.slug.includes("pga-championship");

export const isUSOpenEvent = (event) => event.slug.includes("us-open");

export const isMajorTicketedEvent = (event) =>
  isRyderCupEvent(event) ||
  isPGAChampionshipEvent(event) ||
  isUSOpenEvent(event);

export const pgaTld =
  window.location.origin.includes(".sandboxpga.org") ||
  window.location.origin.includes("localhost")
    ? "sandboxpga.org"
    : "pga.org";
export const myPgaTld =
  window.location.origin.includes(".sandboxpga.org") ||
  window.location.origin.includes("localhost")
    ? "my.dev.pga.com"
    : "my.pga.com";

export const buildMyPgaUrl = (path, slug, ...segments) => {
  const parts = [path, slug, ...segments]
    .filter((s) => typeof s === "string" && s.length > 0)
    .map((s) => s.replace(/^\/+|\/+$/g, ""));
  return `https://${myPgaTld}/${parts.join("/")}`;
};
